<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12.1401 2C8.19352 2 5 5.19352 5 9.14013C5 11.2469 5.92469 13.1439 7.37369 14.45V22L12.1401 20.0934L16.9066 22V14.45C18.3651 13.1439 19.2803 11.2564 19.2803 9.14013C19.2803 5.19352 16.0867 2 12.1401 2ZM12.1401 14.3737C9.25167 14.3737 6.90658 12.0286 6.90658 9.14013C6.90658 6.25167 9.25167 3.90658 12.1401 3.90658C15.0286 3.90658 17.3737 6.25167 17.3737 9.14013C17.3737 12.0286 15.0286 14.3737 12.1401 14.3737ZM9.28027 19.3499V15.6797C10.1573 16.061 11.1201 16.2803 12.1401 16.2803C13.1602 16.2803 14.123 16.061 15 15.6797V19.3499L12.1401 18.082L9.28027 19.3499Z"
      :fill="fillColor"
    />
    <path
      d="M14.9235 6.28049L11.2248 10.0078L9.35631 8.1394L8.1075 9.38821L11.2248 12.4769L16.1723 7.51023L14.9235 6.28049Z"
      :fill="fillColor"
    />
  </svg>
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
})

const fillColor = computed(() => {
  return props.disabled ? '#6C7380' : '#3D424B'
})
</script>
